import { render, staticRenderFns } from "./goodsType.vue?vue&type=template&id=e5f49398&scoped=true&"
import script from "./goodsType.vue?vue&type=script&lang=js&"
export * from "./goodsType.vue?vue&type=script&lang=js&"
import style0 from "./goodsType.vue?vue&type=style&index=0&id=e5f49398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f49398",
  null
  
)

export default component.exports